<template>
    <div></div>
</template>

<script>
    export default {
        data: function () {
            return {
                currentTitle: null,
                interval: null
            }
        },
        methods: {
            on(notificationText) {
                this.currentTitle = document.title;
                this.interval = setInterval(() => {
                    document.title = (this.currentTitle === document.title)
                        ? notificationText
                        : this.currentTitle;
                }, 1000);
            },
            off() {
                window.clearInterval(this.interval);
                this.interval = null;
                if (this.currentTitle) {
                    document.title = this.currentTitle;
                }
            }
        },
        mounted() {
            this.$bus.$on('titleNotification', this.on);
            this.$bus.$on('titleNotificationOff', this.off);
        }
    }
</script>
